import React, { Component } from "react";
import LdsHalfBillboard from "../components/LdsHalfBillboard";
import LdsImage from "../components/LdsImage";
import LdsTile from "../components/LdsTile";
import PullQuote from "../components/PullQuote";
import FigureCaption from "../components/LdsFigureCaption";
import aboutHero from "../assets/about/AMV_EU_Male_Supp_RGB_IM-nb 1.png";
import aboutNegative from "../assets/about/Negative_Brain.png";
import aboutPositive from "../assets/about/positive_brain.png";
import blueCaretRight from "../assets/about/blueCaretRight.svg";
import orangeCaretRight from "../assets/about/orangeCaretRight.svg";
import References from "../components/References";

class About extends Component {
  render() {
    return (
      <main>
        <div className="container">
          <LdsHalfBillboard className="about-hero">
            <LdsHalfBillboard.ContentColumn columnSize="col-12 col-lg-6 order-md-2">
              <PullQuote>
                <p className="h5 pt-4 b gray text-uppercase">In conjunction with clinical assessment,</p>
                <p className="h1 orange b mt-4 mb-4">AMYVID CAN HELP</p>
                <p className="h5 pb-2 b gray text-uppercase">differentiate the cause of cognitive decline<sup>1-3</sup></p>
              </PullQuote>
              <ul className="mt-5">
                <li>
                  Beta-amyloid neuritic plaques may be one of the first
                  biomarker abnormalities in AD<sup>4,5</sup>
                  <ul>
                    <li>
                      Beta-amyloid neuritic plaques may also be present in
                      patients with other types of neurologic conditions, as
                      well as older people with normal cognition; the presence
                      of amyloid plaques alone does not establish a diagnosis of
                      AD or other cognitive disorders<sup>5</sup>
                    </li>
                  </ul>
                </li>
                <li>
                  Evidence of amyloid plaque accumulation has been shown to be
                  present when symptoms of cognitive impairment, due to AD,
                  appear; may even precede the appearance of clinical symptoms
                  by approximately 20 years<sup>2,6-8</sup>
                </li>
                <ul>
                  <li>
                    Amyvid PET scans are interpreted using a binary visual read
                    methodology (negative/positive) and are used as an adjunct
                    to other diagnostic evaluations<sup>1</sup>
                  </li>
                </ul>
                <li>
                  The objective of Amyvid image interpretation is to provide an
                  estimate of the brain β-amyloid neuritic plaque density,
                  not to make a clinical diagnosis; image interpretation is
                  performed independently of a patient’s clinical features and
                  relies upon the recognition of unique image features
                </li>
              </ul>
            </LdsHalfBillboard.ContentColumn>
            <LdsHalfBillboard.ImageColumn
              columnSize="col order-sm-2"
              imgObjectFit="contain"
            >
              <div className="d-flex align-items-end">
                <LdsImage src={aboutHero} alt="Older man with soccer ball with text: 'In conjunction with clinical assessment, Amyvid can help differentiate the cause of cognitive decline'" />
              </div>
            </LdsHalfBillboard.ImageColumn>
          </LdsHalfBillboard>
        </div>
        <div>
          <div className="light-blue-bg section pt-0 pb-0">
            <div className="container p-5">
              <div className="row">
                <div className="col-small-12 col-md-6">
                  <p>
                    A negative Amyvid scan indicates sparse to no neuritic
                    plaques and is inconsistent with a neuropathological
                    diagnosis of AD at the time of image acquisition; a negative
                    scan result reduces the likelihood that a patient's
                    cognitive impairment is due to AD.<sup>1</sup>
                  </p>
                </div>
                <div className="col-small-12 col-md-6">
                  <p>
                    A positive Amyvid scan indicates moderate to frequent
                    amyloid neuritic plaques; neuropathological examination has
                    shown this amount of amyloid neuritic plaque is present in
                    patients with AD but may also be present in patients with
                    other types of neurologic conditions, as well as older
                    people with normal cognition.<sup>1</sup>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <section className="gray-tile section mb-5">
            <div className="row">
              <div className="col-sm-12 col-md-8 offset-md-2">
                <h1 className="b mb-4">
                  <span className="orange">THE VALUE OF KNOWING</span> AMYLOID
                  STATUS
                </h1>
                <h2 className="blue b text-uppercase">
                  <strong>
                    Understanding the value of a negative Amyvid scan
                  </strong>
                </h2>
                <p className="h3 mt-5 mb-3">
                  A negative Amyvid PET scan<sup>1,9</sup>
                </p>
                <ul className="no-indent fz-lg">
                  <li>
                    Low Amyvid uptake in cortical gray matter (good gray-white
                    matter contrast)
                  </li>
                  <li>Indicates sparse to no β-amyloid plaques</li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10 offset-md-1">
                <LdsTile
                  ariaLabel="Supported Browsers"
                  className="white-tile fancy-border mt-4 mb-5"
                  role="region"
                >
                  <LdsTile.Body>
                    <div style={{}} className="m-4 row">
                      <p className="h4 blue text-center b">
                        The value of a negative Amyloid PET scan
                      </p>
                      <div className="col-sm-12 col-md-3">
                        <FigureCaption
                          noCollapse={true}
                          className="figcaption-no-border text-center overflow-hidden"
                          textContent={
                            <>
                              <p className="text-center">
                                ©2016. Avid Radiopharmaceuticals, Inc.
                                <br /> All rights reserved.
                              </p>
                            </>
                          }
                        >
                          <LdsImage
                            src={aboutNegative}
                            alt="Negative Amyvid brain scan showing no significant presence of amyloid plaques."
                            style={{ maxWidth: "175px" }}
                          />
                        </FigureCaption>
                      </div>
                      <div className="col">
                        <div
                          className="d-flex align-items-center"
                          style={{ height: "100%" }}
                        >
                          <LdsImage
                            src={blueCaretRight}
                            alt="Caret Right"
                            style={{ maxWidth: "175px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="d-flex align-items-center justify-content-center flex-column"
                          style={{ height: "100%" }}
                        >
                          <p className="h5 b">Know</p>
                          <p className="fz-lg ps-4">
                            Unlikely that the cause of their cognitive decline
                            is due to AD.
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="d-flex align-items-center"
                          style={{ height: "100%" }}
                        >
                          <LdsImage
                            src={blueCaretRight}
                            alt="Caret Right"
                            style={{ maxWidth: "175px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="d-flex align-items-center justify-content-center flex-column"
                          style={{ height: "100%" }}
                        >
                          <p className="h5 b">Act</p>
                          <ul>
                            <li>
                              Potential to avoid unnecessary treatments
                              <sup>9-11</sup>
                            </li>
                            <li>
                              Together, you and your patient can continue
                              looking into other possible causes of their
                              cognitive impairment
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </LdsTile.Body>
                </LdsTile>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-8 offset-md-2">
                <h2 className="orange b text-uppercase">
                  <strong>
                    Understanding the value of a positive Amyvid scan
                  </strong>
                </h2>
                <p className="h3 mt-5 mb-3 orange">
                  A positive Amyvid PET scan<sup>1,12</sup>
                </p>
                <ul className="no-indent fz-lg">
                  <li>
                    High Amyvid uptake in cortical gray matter (loss of
                    gray-white matter contrast)
                  </li>
                  <li>
                    Indicates moderate to frequent β-amyloid plaques
                    <ul>
                      <li>This amount of beta-amyloid plaque is seen in patients with AD but may also be present in patients with other conditions, as well as cognitively normal older people</li>
                    </ul>
                  </li>
                  <li>A positive Amyvid scan does not establish a diagnosis of AD or other cognitive disorder</li>

                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10 offset-md-1 ">
                <LdsTile
                  ariaLabel="Supported Browsers"
                  className="white-tile fancy-border mt-4 mb-5"
                  role="region"
                >
                  <LdsTile.Body className="orange-outline">
                    <div style={{}} className="m-4 row">
                      <p className="h4 orange text-center b">
                        The value of a Positive Amyloid PET Scan
                      </p>
                      <div className="col-sm-12 col-md-3">
                        <FigureCaption
                          noCollapse={true}
                          className="figcaption-no-border text-center overflow-hidden"
                          textContent={
                            <>
                              <p className="text-center">
                                ©2016. Avid Radiopharmaceuticals, Inc.
                                <br /> All rights reserved.
                              </p>
                            </>
                          }
                        >
                          <LdsImage
                            src={aboutPositive}
                            alt="Positive Amyvid brain scan showing presence of amyloid plaques."
                            style={{ maxWidth: "175px" }}
                          />
                        </FigureCaption>
                      </div>
                      <div className="col">
                        <div
                          className="d-flex align-items-center"
                          style={{ height: "100%" }}
                        >
                          <LdsImage
                            src={orangeCaretRight}
                            alt="Caret Right"
                            style={{ maxWidth: "175px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="d-flex align-items-center justify-content-center flex-column"
                          style={{ height: "100%" }}
                        >
                          <p className="h5 b orange">Know</p>
                          <p className="fz-lg ps-4">
                            Evidence of moderate to frequent β-amyloid
                            plaques in the brain is consistent with a
                            neuropathological diagnosis of AD<sup>1</sup>
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          className="d-flex align-items-center"
                          style={{ height: "100%" }}
                        >
                          <LdsImage
                            src={orangeCaretRight}
                            alt="Caret Right"
                            style={{ maxWidth: "175px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="d-flex align-items-center justify-content-center flex-column"
                          style={{ height: "100%" }}
                        >
                          <p className="h5 b orange">Act</p>
                          <ul>
                            <li>
                              Scan results, along with clinical assessment, may
                              help you decide on appropriate diagnosis and
                              management<sup>13</sup>
                            </li>
                            <li>
                              Together, you and your patient can arrive at a
                              comprehensive, well-informed diagnosis and take
                              appropriate steps
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </LdsTile.Body>
                </LdsTile>
                <p className="text-center">
                  The presence of amyloid plaques alone does not establish a
                  diagnosis of AD or other cognitive disorders<sup>1</sup>
                </p>
              </div>
            </div>
          </section>
        </div>
        <div className="container">
          <References>
            <ol className="no-indent">
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
              <li>
                Jack CR Jr, Albert MS, Knopman DS, et al. Introduction to the
                recommendations from the National Institute on Aging-Alzheimer's
                Association workgroups on diagnostic guidelines for Alzheimer's
                disease. <em>Alzheimers Dement.</em> 2011;7(3):257-262.
              </li>
              <li>
                McKhann GM, Knopman DS, Chertkow H, et al. The diagnosis of
                dementia due to Alzheimer's disease: recommendations from the
                National Institute on Aging-Alzheimer's Association workgroups
                on diagnostic guidelines for Alzheimer's disease.{" "}
                <em>Alzheimers Dement.</em> 2011;7:263-269.
              </li>
              <li>
                Jack CR Jr, Knopman DS, Jagust WJ, et al. Tracking
                pathophysiological processes in Alzheimer's disease: an updated
                hypothetical model of dynamic biomarkers.{" "}
                <em>Lancet Neurol.</em> 2013;12(2):207-216.
              </li>
              <li>
                Trembath L, Newell M, Devous MD Sr. Technical considerations in
                brain amyloid PET imaging with 18F-florbetapir.{" "}
                <em>J Nucl Med Technol.</em> 2015;43(3):175-184.
              </li>
              <li>
                McDade E, Bednar M, Brashear HR, et al. The pathway to secondary
                prevention of Alzheimer's disease. <em>Alzheimers Dement.</em>{" "}
                (NY). 2020;6(1):1-9.
              </li>
              <li>
                Hyman BT, Phelps CH, Beach TG, et al. National Institute on
                Aging-Alzheimer's Association guidelines for the neuropathologic
                assessment of Alzheimer's disease. <em>Alzheimers Dement.</em>{" "}
                2012;8(1):1-13.
              </li>
              <li>
                Villemagne VL, Burnham S, Bourgeat P, et al; for the Australian
                Imaging Biomarkers and Lifestyle (AIBL) Research Group. Amyloid
                ÃŸ deposition, neurodegeneration, and cognitive decline in
                sporadic Alzheimer's disease: a prospective cohort study.{" "}
                <em>Lancet Neurol.</em> 2013;12(4):357-367.
              </li>
              <li>Data on File. Lilly USA, LLC. DOF-AM-US-0008.</li>
              <li>
                Weidman DA, Zamrini E, Sabbagh MN, et al. Added value and
                limitations of amyloid-PET imaging: review and analysis of
                selected cases of mild cognitive impairment and dementia.{" "}
                <em>Neurocase.</em> 2017;23(1):41-51.
              </li>
              <li>
                Shea YF, Barker W, Greig-Gusto MT, et al. Utility of amyloid PET
                scans in the evaluation of patients presenting with diverse
                cognitive complaints. <em>J Alzheimers Dis.</em>{" "}
                2018;66(4):1599-1608.
              </li>
              <li>Data on File. Lilly USA, LLC. DOF-AM-US-0007.</li>
              <li>
                Dubois B, Padovani A, Scheltens P, Rossi A, Dell'Agnello G.
                Timely diagnosis for Alzheimer's disease: a literature review on
                benefits and challenges. <em>J Alzheimers Dis.</em>{" "}
                2016;49(3):617-631.
              </li>
            </ol>
          </References>
        </div>
      </main>
    );
  }
}

export default About;
